import React from 'react';
import {observer} from 'mobx-react';
import {Switch, Route, Redirect} from 'react-router-dom';
import PersonalContainer from './personal/components/PersonalContainer';
import {EmployeeRoleSwitch} from './role';
import BankingContainer from './banking/components/BankingContainer';
import EmergencyContainer from './emergency/components/EmergencyContainer';
import EmployeeDocumentsContainer from './documents/EmployeeDocumentsContainer';
import EmployeeNotesContainer from './notes/NotesContainer';
import {OnboardingContainer} from './onboarding';
import {EmployeeTimeOffSwitch} from './time_off';
import {TrainingContainer} from './training';
import {PerformanceContainer} from './performance';
import {ChangePolicyFlow} from './time_off/components/time_off_policy_selector';

const HrEmployeeProfileSwitch = observer(({uiState}) => {
  const {match, scope} = uiState;

  return (
    <div>
      <Switch>
        <Route path={`${match.url}/personal`} render={() => <PersonalContainer uiState={uiState} />} />
        {scope.job && <Route path={`${match.url}/job`} render={() => <EmployeeRoleSwitch uiState={uiState} />} />}
        {scope.timeOff && <Route path={`${match.url}/time-off`} render={() => <EmployeeTimeOffSwitch uiState={uiState}/>} />}
        {(scope.banking || scope.payroll) && <Route path={`${match.url}/banking`} render={() => <BankingContainer uiState={uiState} />} />}
        {scope.emergency && <Route path={`${match.url}/emergency`} render={() => <EmergencyContainer uiState={uiState} />} />}
        {scope.documents && <Route path={`${match.url}/documents`} render={() => <EmployeeDocumentsContainer uiState={uiState} />} />}
        {scope.training && <Route path={`${match.url}/training`} render={() => <TrainingContainer uiState={uiState} />} />}
        {(scope.reviews || scope.goals || scope.checkins) && <Route path={`${match.url}/performance`} render={() => <PerformanceContainer uiState={uiState} />} />}
        {scope.notes && <Route path={`${match.url}/notes`} render={() => <EmployeeNotesContainer uiState={uiState} />} />}
        {scope.onboarding && <Route path={`${match.url}/onboarding`} render={() => <OnboardingContainer uiState={uiState} />} />}
        <Route path={`${match.url}/change-time-off-policy`} component={ChangePolicyFlow}/>
        <Redirect from={`${match.url}/`} to={`${match.url}/personal`}/>
      </Switch>
    </div>
  );
});

export default HrEmployeeProfileSwitch;
